require('./bootstrap');

/* Vue 3 setup */
// import { createApp } from 'vue'
// import HelloWorld from './components/Welcome'
// import ComboChecker from './components/ComboChecker'

// const app = createApp({});
// app.component('hello-world', HelloWorld);
// app.component('combo-checker', ComboChecker);
// app.mount('#app');
/* END Vue 3 setup */

/* Vue 2 setup */
window.Vue = require('vue').default;
const files = require.context('./components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

const app = new Vue({
    el: '#app',
});
/* END Vue 2 setup */


const loader = new bootstrap.Modal(document.getElementById('loader-modal'));
const loaderPTag = document.getElementById('loader-ptag');

const showLoaders = [...document.getElementsByClassName('showLoader')];
showLoaders.forEach(function(showLoader) {
  showLoader.addEventListener("click", function() {
    let toProcess = this.getAttribute('data-to-process');
    loaderPTag.innerText = (toProcess) ? 'Processing...' : 'Loading...';
    loader.show();
  });
});

const currentPage = encodeURIComponent(window.location.href.replace(/#+$/, ''));
const sharePopUps = [...document.getElementsByClassName('btn-social-share-popup')];
sharePopUps.forEach(function(sharePopUp) {
  sharePopUp.addEventListener("click", function() {
    let url = this.getAttribute('data-share-url');
    window.open(url + currentPage, '123456789' , 'top=200,left=200,height=550,width=500,resizeable=yes');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.snippet-copy-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const key      = btn.dataset.snippet;
      const pre      = document.getElementById('snippet-' + key);
      const text     = pre ? pre.innerText : '';
      const copyText = btn.querySelector('.copy-text');

      if (!text) return;

      // Modern clipboard API with graceful fallback
      const doFallback = () => {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;opacity:0;top:0;left:0;';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        try {
          document.execCommand('copy');
          showCopied();
        } catch (e) {
          console.warn('Copy failed', e);
        } finally {
          document.body.removeChild(ta);
        }
      };

      const showCopied = () => {
        btn.classList.add('copied');
        if (copyText) copyText.textContent = 'Copied!';

        setTimeout(() => {
          btn.classList.remove('copied');
          if (copyText) copyText.textContent = 'Copy';
        }, 2000);
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text)
            .then(showCopied)
            .catch(doFallback);
      } else {
        doFallback();
      }
    });
  });
});
